<template>
  <div class="approvalsList">
    <div class="headerBox">
      <div class="ser">{{ $t('public.approval') }}</div>
      <div class="ser">
        <a-button type="primary" @click="btnapprove">
          {{ $t('public.approve') }}
        </a-button>
        <a-button type="danger" @click="btnReject">
          {{ $t('public.reject') }}
        </a-button>
        <a-button type="primary" @click="btnapproveAll">
          {{ $t('public.approveAll') }}
        </a-button>
      </div>
    </div>
    <div class="contentBox">
      <a-table
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: selectChange
        }"
        :data-source="approvalList"
        :rowKey="approvalList => approvalList.id"
        :scroll="{ x: 1500 }"
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showTotal: total =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange
        }"
      >
        <a-table-column
          :width="150"
          fixed="left"
          :title="$t('public.subject')"
          dataIndex="courseName"
        >
        </a-table-column>
        <a-table-column
          fixed="left"
          :width="150"
          :title="$t('public.student') + $t('public.name')"
          dataIndex="studentName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.student') + $t('report.grade')"
          dataIndex="status"
        >
          <template slot-scope="status">
            <p>{{ status == 9 ? 'Pre10' : status }}</p>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('report.academicYear')"
          dataIndex="academic"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.teacher') + $t('public.name')"
          dataIndex="teacherName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.submitter')"
          dataIndex="submitterName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.approver')"
          dataIndex="approverName"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.scoreType')"
          dataIndex="type"
        >
          <template slot-scope="type">
            <p>
              {{
                type == 1
                  ? 'Regular Grade'
                  : type == 2
                  ? 'Semester Exam'
                  : 'Quiz'
              }}
            </p>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          :title="$t('public.details')"
          dataIndex="details"
        >
        </a-table-column>
        <!-- //323 -->
        <a-table-column
          :width="150"
          :title="$t('public.submissionTime')"
          dataIndex="createTime"
        >
        </a-table-column>
        <a-table-column
          :width="150"
          fixed="right"
          :title="$t('public.oldScore')"
          dataIndex="oldScore"
        >
        </a-table-column>
        <a-table-column
          fixed="right"
          :width="150"
          :title="$t('public.newScore')"
          dataIndex="newScore"
        >
        </a-table-column>

        <a-table-column
          :width="150"
          fixed="right"
          :title="$t('public.operate')"
          dataIndex="id"
        >
          <template slot-scope="id, approvalList">
            <a @click="() => btnapproveOne(approvalList.id)">{{
              $t('public.approve')
            }}</a>
            <div class="border"></div>
            <a @click="() => btnRejectOne(approvalList.id)">{{
              $t('public.reject')
            }}</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      selectedRowKeys: [],
      pageSize: 10,
      total: 0,
      current: 1,
      approvalList: []
    }
  },
  methods: {
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    currentChange(pageNumber) {
      let data = {
        pageSize: this.pageSize,
        pageNO: pageNumber,
        userId: this.userId
      }
      this.current = pageNumber
      this.approvalData(data)
    },
    approvalData(data) {
      this.$http(this.$api.APPROVALDATAAPI, data).then(r => {
        if (r.data.total > 0) {
          this.total = r.data.total
        }
        // this.total = r.data.total
        this.approvalList = r.data.rows
      })
    },
    btnapprove() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let data = {
        id: JSON.stringify(this.selectedRowKeys)
      }
      this.operationTips(
        this.$t('public.approve'),
        this.$t('public.approveTips') + this.$t('public.approve'),
        this.approveAdopt(data)
      )
    },
    btnReject() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let data = {
        id: JSON.stringify(this.selectedRowKeys)
      }
      this.operationTips(
        this.$t('public.reject'),
        this.$t('public.approveTips') + this.$t('public.reject'),
        this.approveReject(data)
      )
    },
    //同意得点击
    btnapproveOne(id) {
      let data = [id]
      this.operationTips(
        this.$t('public.approve'),
        this.$t('public.approveTips') + this.$t('public.approve'),
        this.approveAdopt({
          id: JSON.stringify(data)
        })
      )
    },
    //拒绝得点击
    btnRejectOne(id) {
      let data = [id]
      this.operationTips(
        this.$t('public.reject'),
        this.$t('public.approveTips') + this.$t('public.reject'),
        this.approveReject({
          id: JSON.stringify(data)
        })
      )
    },
    //全部同意
    btnapproveAll() {
      if (this.approvalList == null) return false
      this.operationTips(
        this.$t('public.approveAll'),
        this.$t('public.approveTips') + this.$t('public.approveAll'),
        this.approveAllAdopt()
      )
    },
    //审批同意
    approveAdopt(approveData) {
      return () => {
        this.$http(this.$api.APPROVALADOPT, approveData).then(r => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            let data = {
              pageSize: this.pageSize,
              pageNO: this.current,
              userId: this.userId
            }
            this.approvalData(data)
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description: this.$t('public.approval') + this.$t('class.success')
            })
          }
        })
      }
    },
    //全部审批同意
    approveAllAdopt() {
      return () => {
        this.$http(this.$api.APPROVALALLADOPT).then(r => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            let data = {
              pageSize: this.pageSize,
              pageNO: this.current
            }
            this.approvalData(data)
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description: this.$t('public.approval') + this.$t('class.success')
            })
          }
        })
      }
    },
    //拒绝审批
    approveReject(approveData) {
      return () => {
        this.$http(this.$api.APPROVALREJECT, approveData).then(r => {
          if (r.code == 0) {
            this.selectedRowKeys = []
            let data = {
              pageSize: this.pageSize,
              pageNO: this.current
            }
            this.approvalData(data)
            this.$notification.open({
              type: 'success',
              message: this.$t('public.approval'),
              description: this.$t('public.approval') + this.$t('class.success')
            })
          }
        })
      }
    },
    operationTips(title, content, callBack) {
      this.$confirm({
        title: title,
        content: content,
        onOk() {
          callBack()
        }
      })
    }
  },
  created() {
    // let userId =
    let data = {
      pageSize: this.pageSize,
      pageNO: this.current,
      userId: this.userId
    }
    this.approvalData(data)
  },
  computed: {
    ...mapGetters(['userId'])
  }
}
</script>

<style lang="less" scoped>
.approvalsList {
  width: 100%;
  height: calc(100% - 150px);

  .headerBox {
    width: 100%;
    height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    background-color: #fff;
    .ser {
      width: 50%;
      height: 100%;
      line-height: 60px;
      float: left;
      font-size: 15px;
    }

    .ser:last-child {
      /deep/ .ant-btn {
        float: right;
        margin-top: 15px;
        margin-left: 10px;
      }
    }
  }

  .contentBox {
    width: 100%;
    height: 100%;
  }
  /deep/ .ant-table-tbody {
    /deep/ .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
  .ant-btn-danger {
    background-color: #f5222d;
    color: white;
  }
}
</style>
